import React from "react";
import ImageService from "../services/image.service";

export const services = {
    imageService: new ImageService()
};

const ApiContext = React.createContext(services);

export default ApiContext;